export default __webpack_public_path__ + "854ef339a6a472a85331530126f01d6e.svg";